module.exports = __webpack_public_path__ + "static/media/kylemore-cars.6730467e.png";